import {Component, EventEmitter, Input, Output} from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-input-number',
    templateUrl: './input-number.component.html',
    styleUrls: ['./input-number.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass]
})
export class InputNumberComponent {
    @Input() submitted: boolean; // Si le form a été soumis au moins une fois
    @Input() control: AbstractControl; // FormControl
    @Input() fcName: string; // Nom du FormControl
    @Input() textLabel: string; // Label
    @Input() group; // Group contenant le FormControle
    @Input() i = 0; // i si l'input est dans une boucle (pour éviter d'avoir 2 composants ayant le même id
    @Input() textLabel2 = '';
    @Input() modelAttribute: unknown; // Valeur entrée
    @Input() min: number; // Minimum de l'input
    @Output() modelAttributeChange = new EventEmitter(); // Valeur envoyée au parent

    change(newValue) {
        this.modelAttribute = newValue;
        this.modelAttributeChange.emit(newValue);
    }

}
